module.exports = __webpack_public_path__ + "linea-arrows-10.9b287297a8d930c35c32.eot";


//////////////////
// WEBPACK FOOTER
// C:/Users/INMOGR/Desktop/Angular Project/src/assets/fonts/linea/arrows/fonts/linea-arrows-10.eot
// module id = ../../../../../src/assets/fonts/linea/arrows/fonts/linea-arrows-10.eot
// module chunks = styles